<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.16667 18.3332H5.41667C4.97464 18.3332 4.55072 18.1576 4.23816 17.845C3.92559 17.5325 3.75 17.1085 3.75 16.6665V3.33318C3.75 2.89115 3.92559 2.46723 4.23816 2.15467C4.55072 1.8421 4.97464 1.66651 5.41667 1.66651H12.0833C12.3474 1.66586 12.609 1.71752 12.853 1.8185C13.097 1.91948 13.3186 2.06778 13.505 2.25484L16.495 5.24484C16.6821 5.43124 16.8304 5.65283 16.9313 5.89684C17.0323 6.14085 17.084 6.40243 17.0833 6.66651V11.6665"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.0833 1.6665V5.83317C12.0833 6.05418 12.1711 6.26615 12.3274 6.42243C12.4837 6.57871 12.6956 6.6665 12.9167 6.6665H17.0833"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.0833 16.6667L13.75 18.3333L17.0833 15"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconFileCheck',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
